import { useState } from 'react';

export const useObscurePassword = ({ onObscurePasswordChange }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [shouldNextClickShowPassword, setShouldNextClickShowPassword] = useState(true);
    const handleShowPasswordChange = show => {
        setShowPassword(show);
        onObscurePasswordChange(show);
    };

    const handleShowPasswordClick = () => {
        handleShowPasswordChange(shouldNextClickShowPassword);
        setShouldNextClickShowPassword(prevState => !prevState);
    };

    return {
        showPassword,
        handleShowPasswordTouchStart: () => handleShowPasswordChange(true),
        handleShowPasswordTouchEnd: () => handleShowPasswordChange(false),
        handleShowPasswordChange,
        handleShowPasswordClick,
    };
};
